export class PagingConfig {
  //#region Fields
  public pageNumber: number;
  public pageSize: number;
  public count: number;
  public next: boolean ;
  public results: any[];
  //#endregion Fields
  constructor(){
    this.pageNumber= 1;
    this.pageSize=10;
    this.count=0
    this.results= [];
    this.next = true;
  }
 }
